import { motion } from "framer-motion";
import { FileText, MessageSquareX, UserSearch, CreditCard, Database, BarChart2 } from "lucide-react";

const problems = [
  {
    icon: FileText,
    title: "Manual Administration",
    desc: "Paperwork and spreadsheets slow down school operations.",
  },
  {
    icon: MessageSquareX,
    title: "Poor Communication",
    desc: "Teachers, parents, and administrators struggle to stay connected.",
  },
  {
    icon: UserSearch,
    title: "Student Tracking Difficulties",
    desc: "Monitoring attendance and academic performance becomes complicated.",
  },
  {
    icon: CreditCard,
    title: "Fee Management Issues",
    desc: "Manual fee tracking leads to errors and delays.",
  },
  {
    icon: Database,
    title: "Data Disorganization",
    desc: "Important student and academic data are often scattered across different systems.",
  },
  {
    icon: BarChart2,
    title: "Lack of Real-Time Insights",
    desc: "School leaders cannot easily access reports and performance analytics to make informed decisions.",
  },
];

const ChallengesSection = () => (
  <section className="py-24 bg-white dark:bg-slate-950">
    <div className="container mx-auto px-4 lg:px-8 max-w-6xl">
      <div className="text-center mb-16 max-w-3xl mx-auto">
        <span className="inline-block px-4 py-1.5 rounded-full bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300 text-xs font-bold uppercase tracking-wider mb-6">
          PROBLEMS
        </span>
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-slate-800 dark:text-slate-100 mb-6 tracking-tight">
          Challenges Schools Face Today
        </h2>
        <p className="text-lg text-slate-500 dark:text-slate-400 font-medium leading-relaxed">
          Managing a school involves many daily tasks that can become inefficient without the right system.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {problems.map((p, i) => (
          <motion.div
            key={i}
            className="flex flex-col gap-4 p-6 rounded-2xl bg-slate-50 dark:bg-slate-900/50 hover:bg-red-50 dark:hover:bg-red-900/10 border border-slate-100 dark:border-slate-800 hover:border-red-100 dark:hover:border-red-900/30 transition-all group"
          >
            <div className="w-12 h-12 rounded-xl bg-red-100 dark:bg-red-900/40 flex items-center justify-center text-red-500 dark:text-red-400">
              <p.icon className="w-6 h-6" />
            </div>
            <div>
              <h3 className="font-bold text-slate-800 dark:text-slate-200 mb-2">{p.title}</h3>
              <p className="text-slate-500 dark:text-slate-400 text-sm leading-relaxed">{p.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default ChallengesSection;
